import { render, staticRenderFns } from "./CanvasDebugUI.vue?vue&type=template&id=72ac99e5&scoped=true&"
import script from "./CanvasDebugUI.vue?vue&type=script&lang=js&"
export * from "./CanvasDebugUI.vue?vue&type=script&lang=js&"
import style0 from "./CanvasDebugUI.vue?vue&type=style&index=0&id=72ac99e5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac99e5",
  null
  
)

export default component.exports